import { useCallback, useEffect, useState } from 'react'

import {
  checkIsEndOfContainer,
  checkIsStartOfContainer,
} from '../../ScrollSlider.utils'

export function useScrollSliderButtons({ itemGap, itemWidth, sliderRef }) {
  const [isNextBtnVisible, setNextBtnVisible] = useState(false)
  const [isPrevBtnVisible, setPrevBtnVisible] = useState(false)

  useEffect(() => {
    if (sliderRef.current) {
      updateBtnsVisible()
    }
  }, [sliderRef.current])

  const handleClickNext = useCallback(() => {
    sliderRef.current.scrollTo(
      sliderRef.current?.scrollLeft + itemWidth + itemGap,
      0
    )
  }, [itemGap, itemWidth])

  const handleClickPrev = useCallback(() => {
    sliderRef.current.scrollTo(
      sliderRef.current?.scrollLeft - itemWidth - itemGap,
      0
    )
  }, [itemGap, itemWidth])

  function updateBtnsVisible() {
    const isEndOfContainer = checkIsEndOfContainer(sliderRef.current)
    const isStartOfContainer = checkIsStartOfContainer(sliderRef.current)

    if (isEndOfContainer) {
      setNextBtnVisible(false)
    }

    if (!isEndOfContainer && !isNextBtnVisible) {
      setNextBtnVisible(true)
    }

    if (isStartOfContainer) {
      setPrevBtnVisible(false)
    }

    if (!isStartOfContainer && !isPrevBtnVisible) {
      setPrevBtnVisible(true)
    }
  }

  return {
    handleClickNext,
    handleClickPrev,
    isNextBtnVisible,
    isPrevBtnVisible,
    updateBtnsVisible,
  }
}
